module.exports = "<p><%= noSearchCriteriaMsg %></p>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna_csg_gsg_elasticsearch/src/js/views/no-search-criteria.tpl.html
// module id = uCtF
// module chunks = 4